import {environment} from '../../../../environments/environment';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

export abstract class AbstractMatTable {

  public displayedColumns: string[] = [];
  public pageSizeOptions: number[] = environment.pageSizeOptions;
  public pageSize: number = environment.pageSize;
  public showSpinner: boolean;
  public matTableDataSource: MatTableDataSource<any>;
  public sort: MatSort;
  public paginator: MatPaginator;

  public applyFilter(filterValue: string): void {
    this.matTableDataSource.filter = filterValue.trim().toLowerCase();
  }

  protected setMatTable(observable: Observable<any>, displayedColumns : string[] = []): Subscription {
    this.displayedColumns = displayedColumns;
    this.showSpinner = true;
    return observable.subscribe(
      (dataSource: any[]) => {
        this.setMatTableDataSource(dataSource);
        this.showSpinner = false;
      },
      () => {
        this.showSpinner = false;
      });
  }

  private setMatTableDataSource(dataSource: any[]): void {
    this.matTableDataSource = new MatTableDataSource(dataSource);
    this.matTableDataSource.sort = this.sort;
    this.matTableDataSource.paginator = this.paginator;
    this.matTableDataSource.paginator.firstPage();
    this.matTableDataSource.filter = '';
  }
}
